import React, { Component } from 'react';
import moment from 'moment';
import ReactGA from 'react-ga';

const API_URL = process.env.REACT_APP_BASE_URL;

class EventItem extends Component {

	logEvent = (event) => {
		ReactGA.event({
			category: 'Event',
			action: 'More Information (' + event.title + ')',
			label: event.title + ' - ' + event.links.info
		});
	}

	renderAddress() {
		const address = this.props.event.contacts;

		const venue = address.venue_name ? address.venue_name + '<br/>' : '';
		const address1 = address.address_1 ? address.address_1 + '<br/>' : '';
		const address2 = address.address_2 ? address.address_2 + '<br/>' : '';
		const borough = address.borough ? address.borough + ', ' : '';

		if (venue !== '') {
			return (
				<div className="mt-2">
					<label className="mb-0 font-weight-bold" htmlFor="address">VENUE</label>
					<address id="address">
						<p className="mb-0" dangerouslySetInnerHTML={{ __html: venue }} />
						<p className="mb-0" dangerouslySetInnerHTML={{ __html: address1 }} />
						<p className="mb-0" dangerouslySetInnerHTML={{ __html: address2 }} />
						{borough}{address.postcode}
					</address>
				</div>
			);
		}
	}

	renderCost() {
		const event = this.props.event;

		return (
			<div className="mt-2">
				{event.cost !== null ? <p className="mb-0"><span className="font-weight-bold">COST: </span> £{event.cost}</p> : <p className="font-weight-bold mb-0">FREE</p>}
			</div>
		);
	}

	renderEventDates() {
		const eventDate = moment(this.props.event.start_date).format("ddd, D MMM YYYY");
		const endDate = moment(this.props.event.end_date).format("ddd, D MMM YYYY");
		const eventTime = moment(this.props.event.start_date).format("H:mm");
		const endTime = moment(this.props.event.end_date).format("H:mm");

		if (eventDate === endDate) {
			if (eventTime !== '0:00' && endTime !== '0:00') {
				return (
					<div className="mt-2">
						{eventDate}
						<br />
						{eventTime} - {endTime}
					</div>
				);
			} else {
				return (
					<div className="mt-2">
						{eventDate}
					</div>
				);
			}
		} else if (eventTime === '0:00' && endTime === '0:00') {
			return (
				<div className="mt-2">
					<span className="font-weight-bold">START </span> {eventDate}
					<br />
					<span className="font-weight-bold">FINISH </span> {endDate}
				</div>
			);
		} else {
			return (
				<div className="mt-2">
					<span className="font-weight-bold">START </span> {eventDate}  ({eventTime})
					<br />
					<span className="font-weight-bold">FINISH </span> {endDate}  ({endTime})
				</div>
			);
		}
	}

	renderArtformAndKeystages () {
		const event = this.props.event;
		const artforms = [];

		event.artforms.map((art, index) => {
			if (index === 0) {
				artforms.push(art.charAt(0).toUpperCase() + art.slice(1));
			} else {
				artforms.push(art.toLowerCase());
			}
		});

		return (
			<div className="mb-2">
				<div className="mb-0">
					{event.artforms.length !== 0 ?
						<span className="font-weight-bold">Artform</span>
						: <div><span className="font-weight-bold">Artform</span> - not specific</div>
					}
					{event.artforms.length !== 0 ? ' - ' + artforms.join(', ') : ''}
				</div>
				<div>
					{event.keystages.length !== 0 ?
						<span className="font-weight-bold">Key stage</span>
						: <div><span className="font-weight-bold">Key stage</span> - not specific</div>
					}

					{event.keystages.length !== 0 ? ' - ' + event.keystages.join(', ').replace('0', 'EY') : ''}
				</div>
			</div>
		);
	}

	render() {
		const event = this.props.event;
		const eventLogo = (event.links.logo) ? <img className="p-1" src={API_URL + 'storage/' + event.links.logo} alt="" style={{ maxHeight: '200px', float: 'right' }} /> : '';

		return (
			<div className="event-detail border-bottom">
				<div className="container">
					<div className="row no-gutters mb-2 mb-md-0">
						<div className="col-12 col-md-8">
							<div className="event-detail-border tab-filter-item my-2">
								<div className="row">
									<div className="col-12 col-md-8">
										<h2 className="mb-1">{event.title}</h2>
									</div>
								</div>

								<div className="row">
									<div className="col-12 col-md-8">
										<p className="font-weight-bold mb-0 mt-1">
											<a href={'/search/'+ event.organisation.id + '/events'}>{event.organisation.title}</a>
										</p>
										<p>{event.info}</p>


{this.renderArtformAndKeystages()}


										{(event.support_send) ? <p className="font-weight-bold">Accessible for SEND students</p> : ''}
										{(event.links.info) ? <a onClick={() => this.logEvent(event)} href={event.links.info} className="font-weight-bold" target="_blank" rel="noopener noreferrer"><i className="fa fa-angle-double-right" aria-hidden="true"></i> MORE INFORMATION</a> : ''}
									</div>

									<div className="col-12 col-md">
										{eventLogo}
									</div>
								</div>
							</div>
						</div>

						<div className="col-12 col-md-4 pl-0">
							<div className="p-md-2 tab-filter-item-border h-100 d-flex flex-column">
								<div className="d-flex">
									<h3 className="text-uppercase text-danger mb-0">
										{event.event_type_name}
									</h3>

									<div className="ml-auto">
										{(event.organisation.artsmark_partner === true) ? <a href="https://www.anewdirection.org.uk/artsmark" className="ml-1 d-inline-block"> <img src="/artsmark-logo.png" alt="artsmark logo" style={{ height: '30px' }} /></a> : ''}
										{(event.organisation.arts_award_supporter === true) ? <a href="https://www.artsawardsupporter.com/" className="ml-1 d-inline-block"> <img src="/arts-award-logo.png" alt="arts award logo" style={{ height: '30px' }} /></a> : ''}
									</div>
								</div>

								{this.renderEventDates()}
								{this.renderCost()}
								{this.renderAddress()}

								{(event.delivered_in_school) ? <div className="font-weight-bold mt-2">Delivered in your school</div> : ''}
								{(event.webinar) ? <div className="font-weight-bold mt-2">Webinar</div> : ''}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
};

export default EventItem;